<template>
  <div>
    <h2>Unauthorized!</h2>
    <p>You are not authorized to access this page.</p>
  </div>
</template>

<script>
export default {
  name: 'Unauthorized',
};
</script>

<style scoped lang="scss">
div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
